import { useTranslation, Trans } from 'react-i18next'
import type { Persona } from '../types'
import { Button } from '@/components/ui/Button'

interface DeletePersonaModalProps {
  persona: Persona
  isPending: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function DeletePersonaModal({ persona, isPending, onConfirm, onCancel }: DeletePersonaModalProps) {
  const { t } = useTranslation()

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} aria-hidden="true" />
      <div className="relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <h2 id="delete-modal-title" className="text-base font-semibold text-neutral-900">
            {t('personas.delete_title')}
          </h2>
          <p className="text-sm text-neutral-600">
            <Trans
              i18nKey="personas.delete_warning"
              values={{ name: persona.name }}
              components={[<strong key="name" />]}
            />
          </p>
        </div>
        <div className="flex gap-3">
          <Button variant="secondary" onClick={onCancel} className="flex-1 min-h-[44px]">
            {t('common.cancel')}
          </Button>
          <Button
            isLoading={isPending}
            onClick={onConfirm}
            className="flex-1 min-h-[44px] bg-mindeia-error text-white hover:bg-red-700 border-transparent"
          >
            {t('common.delete')}
          </Button>
        </div>
      </div>
    </div>
  )
}
